import ArchkNotificationDelete from 'archk-notification-delete';
import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import { architeckCall } from 'database';
import keys from 'keys';
import moment from 'moment';
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { CSVExport, Search } from "react-bootstrap-table2-toolkit";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Modal, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';

const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;

const pagination = paginationFactory({
    sizePerPage: 10,
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
        <div className="dataTables_length" id="datatable-basic_length">
            <label>
                Show{" "}
                {<select
                    name="datatable-basic_length"
                    aria-controls="datatable-basic"
                    className="form-control form-control-sm"
                    onChange={e => onSizePerPageChange(e.target.value)}
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>}{" "}
                entries.
            </label>
        </div>
    )
});

const required_form_fields = [
    'minutes',
    'problems',
    'description',
]  

class Developers extends React.Component {

    state = {
        log: {},
        project_logs_developers: []
    }

    update = async () => {

        this.setState({canSave: false})
        //copy state
        let newState = Object.assign({}, this.state.log);
        //assume we have no errors
        let errors = 0;

        required_form_fields.forEach((field) => {
            //check each required field
            if(newState[field]) {
                newState[field + "State"] = 'valid'; 
            } else {
                newState[field + "State"] = 'invalid'; 
                errors++
            }

        })

        this.setState({ log: newState });

        if(!errors) { 

            const cost = parseInt(this.props.viewing_user.hourly_rate) * (parseInt(newState.minutes) / 60)

            const updated = await architeckCall({
                method: 'patch',
                url: '/api/v1/crud/project_logs_developers/update/' + newState._id,
                data: {
                    ...newState,
                    cost 
                },
            });

           this.onToggleModal({})

            if(updated.success) {

                 //reset project_logs_developers
                this.setState({logs: {}})

                let project_logs_developers = [...this.state.project_logs_developers]
    
                project_logs_developers[project_logs_developers.findIndex(el => el._id === newState._id)] = {...newState, cost};
                this.setState({project_logs_developers})
                
            } else {

                toggleAlert(true, 'danger', 'An error occurred.', 'infinite' )
                console.log(updated)

            }

        }

        //after load make sure button work again
        this.setState({canSave: true})

    }

    onInputChange = (e, stateName) => {

        let newState = Object.assign({}, this.state.log);
        newState[stateName] = e.target.value;

        if (stateName === "checkbox") {
          if (e.target.value) {
            newState.checkboxState = "valid";
          } else {
            newState.checkboxState = "invalid";
          }
        } else {
          if (e.target.value === "") {
            newState[stateName + "State"] = "invalid";
          } else {
            newState[stateName + "State"] = "valid";
          }
        }

        this.setState({ log: newState });
    };

    onToggleModal = (log) => this.setState({ log }) 

    showDeletionAlert = (row) => {
        this.setState({deletionAlert: (
            <ArchkNotificationDelete
                onSuccess={(response) => {

                    if(response.success) {

                        let project_logs_developers = [...this.state.project_logs_developers];
                        project_logs_developers = project_logs_developers.filter(f => f._id !== response.data.document_ids_sent[0]);
                
                        this.setState({project_logs_developers})

                    } else {

                        toggleAlert(true, 'danger', 'An error occurred.', 'infinite' )
                        console.log(response)

                    }
                }}
                onError={(response) => {
                    console.log(response)
                    toggleAlert(true, 'danger', 'An error occurred.', 'infinite' )
                }}
                onClose={() => this.setState({deletionAlert: null})}


                deletionURL={`${keys.API_URL}/api/v1/crud/project_logs_developers/delete/${row._id}`}
                apiKey={keys.SYSTEM_API_KEY}

                text="Are you sure you wish to delete this log? This cannot be undone."
                title={`Delete Project Log`}
            />
        )})
    }

    componentDidMount = async () => {

        let project_logs_developers = await architeckCall({
            method: 'get',
            url: `/api/v1/project_logs_developers/list?find_by=user__${this.props.viewing_user._id}&loop=true&limit=500`
        })

        if(project_logs_developers.success) {

            this.setState({project_logs_developers: project_logs_developers.data})

        } else {

            toggleAlert(true, 'danger', 'An error occurred fetching your project log data.', 'infinite' )

        }

    }

    columns = [
        {
            dataField: "created_at",
            text: "Created ON",
            sort: true,
            formatter: (cell, row) => moment.unix(row.created_at).format("MM/DD/YYYY")
        },
        {
            dataField: "project",
            text: "Project",
            sort: true,
            formatter: (cell, row) => (
                <Link to={`/developers/projects/${row.project._id}`}>
                    {row.project.name}
                </Link>
            )
        },
        {
            dataField: "description",
            text: "Description",
            sort: true,
            formatter: (cell, row) => (
                <span>
                    {row.description && row.description.length > 30 ? row.description.slice(0,30) + '...' : row.description}
                </span>
            )
        }, {
            dataField: "problems",
            text: "Problems",
            sort: true,
            formatter: (cell, row) => (
                <span>
                    {row.problems && row.problems.length > 15 ? row.problems.slice(0,15) + '...' : row.problems}
                </span>
            )
        }, {
            dataField: "minutes",
            text: "Minutes",
            sort: true,
            formatter: (cell, row) => (
               <span>{row.minutes}</span>
            )
        }, {
            dataField: "cost",
            text: "Billable",
            sort: true,
            formatter: (cell, row) => (
               <span>${(row.cost / 100).toFixed(2)}</span>
            )
        }, {
            dataField: "",
            text: "Actions",
            sort: false,
            headerFormatter: (column) => <div className="text-right">Actions</div>,
            formatter: (cell, row) => {

                let current_time  = (Math.floor(new Date() / 1000));
                let one_week_unix_time = 604800;
                let last_week = current_time - one_week_unix_time

                //if this was created at a date before last week set disabled to true
                let disabled = row.created_at < last_week ? true : false

                return (
                    <div className="text-right">

                        <button onClick={() => this.onToggleModal(row)} disabled={disabled} className="btn btn-sm btn-primary">
                            <i className="fas fa-edit mr-2" />Edit 
                        </button>
                        <button  disabled={disabled}  onClick={() => this.showDeletionAlert(row)} className="btn btn-sm btn-danger">
                            <i className="fas fa-trash mr-2" />
                            Delete
                        </button>
                    
                    </div>
                )
            }
        }
    ]

    render() {

        const project_logs_developers = this.state.project_logs_developers
        const log = this.state.log;

        return (

            <Container>     

                <Helmet>
                    <title>Project Logs All</title>
                    <meta name="description" content="Project Logs All" />
                </Helmet>

                {this.state.deletionAlert}

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers" 
                    title={<span>Dashboard</span>} breadcrumb_1="Project Logs"  
                />

                <Modal 
                    className="modal-full modal-dialog-centered" 
                    size="lg"  
                    isOpen={log._id ? true : false} 
                    toggle={() => this.onToggleModal({})}  
                >
                    <div className="modal-body">
                        <h2>Update Entry</h2>
                        <p>{moment.unix(log.created_at).format("MM/DD/YYYY")}</p>
                        <hr className="my-2" />

                        <FormGroup>
                            <label className="form-control-label" htmlFor="minutes" > 
                                Minutes Worked
                            </label>
                            <Input
                                id="minutes"
                                value={log.minutes || ''}
                                placeholder="60"
                                type="number"
                                valid={ log.minutesState === "valid" }
                                invalid={ log.minutesState === "invalid" }
                                onChange={e => this.onInputChange(e, "minutes") }
                            />
                            <div className="valid-feedback">Looks good!</div>
                        </FormGroup>

                        <FormGroup>
                            <label className="form-control-label" htmlFor="description" > 
                            What Got Done:
                            </label>
                            <Input
                                id="description"
                                value={log.description || ''}
                                placeholder="Added in API routes for... Created pages... fixed bug..."
                                type="textarea"
                                valid={ log.descriptionState === "valid" }
                                invalid={ log.descriptionState === "invalid" }
                                onChange={e => this.onInputChange(e, "description") }
                            />
                            <div className="valid-feedback">Looks good!</div>
                        </FormGroup>

                        <FormGroup>
                            <label className="form-control-label" htmlFor="problems" > 
                                Any Problems Encountered
                            </label>
                            <Input
                                id="problems"
                                value={log.problems || ''}
                                placeholder="After I clicked on... this happened..."
                                type="textarea"
                                valid={ log.problemsState === "valid" }
                                invalid={ log.problemsState === "invalid" }
                                onChange={e => this.onInputChange(e, "problems") }
                            />
                            <div className="valid-feedback">Looks good!</div>
                        </FormGroup>

                        <div className="text-right mt-3">
                            <button onClick={this.update} className="btn btn-success">Update</button>
                        </div>


                    </div>
                </Modal>

                <Card>


                    <CardHeader>
                        <h2>All Project Logs</h2>
                        <p>Note you cannot update or delete a log that is older than 1 week.</p>
                    
                    </CardHeader>

                    <CardBody>

                        <div className="table-vertical-align">
                            <ToolkitProvider
                                data={project_logs_developers}
                                keyField="_id"
                                columns={this.columns}
                                search
                                exportCSV
                            >
                            {props => (
                                <div className="py-4 table-responsive table-vertical-align">
                                    <div id="datatable-basic_filter" className="dataTables_filter px-4 pb-1 w-100" >
                                        <Row>

                                            <Col>
                                                <label>
                                                    Search:
                                                    <SearchBar className="form-control-sm" placeholder="" {...props.searchProps}/>
                                                </label>
                                            </Col>

                                            <Col className="col-auto">
                                                <ExportCSVButton { ...props.csvProps } className="btn-sm btn-success" >
                                                    <span>Export CSV</span>
                                                </ExportCSVButton>
                                            </Col>

                                        </Row>
                                    </div>
                                    <BootstrapTable 
                                        {...props.baseProps} 
                                        className="xxx" 
                                        bootstrap4={true} 
                                        pagination={pagination} 
                                        bordered={false}
                                    />
                                </div>
                            )}
                            </ToolkitProvider>
                        </div>

                    </CardBody>
                </Card>

            </Container>

        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
      app_projects: state.projects.app_projects,

    };
};
  
export default connect(mapStateToProps, '')(Developers);